"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var pageDiyRouter = {
  path: '/page',
  component: _layout.default,
  redirect: '/page/design/devise',
  name: 'PageDiy',
  meta: {
    title: '装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'design',
    name: 'design',
    alwaysShow: true,
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/pagediy'));
      });
    },
    meta: {
      title: '页面管理',
      roles: ['admin']
    },
    children: [{
      path: 'devise',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/pagediy/devise/index'));
        });
      },
      name: 'viewDevise',
      meta: {
        title: '页面装修',
        noCache: true
      }
    }, {
      path: 'viewDesign',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/pagediy/viewDesign'));
        });
      },
      name: 'viewDesign',
      meta: {
        title: '页面设计',
        noCache: true
      }
    }, {
      path: 'theme',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/pagediy/theme'));
        });
      },
      name: 'theme',
      meta: {
        title: '一键换色',
        noCache: true
      }
    }, {
      path: 'picture',
      name: 'picture',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/maintain/picture'));
        });
      },
      meta: {
        title: '素材管理',
        icon: 'clipboard'
      },
      hidden: false
    }, {
      path: 'advertisement',
      name: 'advertisement',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/pagediy/advertisement'));
        });
      },
      meta: {
        title: '开屏广告',
        icon: 'clipboard'
      },
      hidden: false
    }]
  }]
};
var _default = exports.default = pageDiyRouter;